/**
 * @param {function} setData setter functions - to reset the state in parent component
 * @param {number} rowIndex index of row being deleted
 * @param {Object[]} initialData initial data for table; what's required to make an empty row
 */
export const resetStateAfterDelete = (setData, rowIndex, initialData) => {
    setData(prevData => {

        let newData = []

        //if there was only one item in state before, now there will be zero, so replace with initial data
        if(prevData.length <= 1){
                
            newData = [...initialData]

        } else {
                
            newData = [...prevData];
    
            newData.splice(rowIndex, 1);
        }

        return newData;
    });
}